/**
 * Helpers visuels partagés par toutes les modales Customer Success.
 */
export const COLORS = [
  'bg-emerald-500', 'bg-blue-500', 'bg-violet-500',
  'bg-amber-500', 'bg-rose-500', 'bg-indigo-500', 'bg-teal-500',
];

export const initialsBg = (name = '') => {
  const h = (name || '').split('').reduce((a, c) => a + c.charCodeAt(0), 0);
  return COLORS[h % COLORS.length];
};

export const initials = (name = '') =>
  (String(name || '').split(' ').filter(Boolean).slice(0, 2).map((w) => w[0]).join('') || 'CL').toUpperCase();

export const PRIORITY_BADGE = {
  haute: 'bg-red-50 text-red-700 border-red-200',
  moyenne: 'bg-amber-50 text-amber-700 border-amber-200',
  basse: 'bg-emerald-50 text-emerald-700 border-emerald-200',
};

export const PRIORITY_LABEL = {
  haute: 'Haute priorité',
  moyenne: 'Moyenne priorité',
  basse: 'Faible priorité',
};

export const RISK_BADGE = {
  faible: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  a_surveiller: 'bg-amber-50 text-amber-700 border-amber-200',
  a_relancer: 'bg-red-50 text-red-700 border-red-200',
};
export const RISK_LABEL = {
  faible: 'Client actif',
  a_surveiller: 'À surveiller',
  a_relancer: 'À relancer',
};

export const fmtFcfa = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '—';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace('.0', '')}M FCFA`;
  if (n >= 1_000) return `${(n / 1_000).toFixed(0)}k FCFA`;
  return `${n} FCFA`;
};

export const fmtFcfaFull = (n) => {
  if (n === null || n === undefined || isNaN(n)) return '—';
  return `${new Intl.NumberFormat('fr-FR').format(n)} FCFA`;
};

export const fmtDateFr = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  } catch { return '—'; }
};

export const daysSince = (iso) => {
  if (!iso) return null;
  const d = new Date(iso);
  return Math.max(0, Math.floor((Date.now() - d.getTime()) / 86400000));
};

// Message suggéré paramétrable par contexte
export const buildSuggestedMessage = (companyName, daysInactive = null) => {
  const lines = [
    `Bonjour ${companyName || 'Client'},`,
    '',
  ];
  if (daysInactive !== null && daysInactive > 0) {
    lines.push(`Nous constatons que vous n'avez pas effectué de demande depuis ${daysInactive} jour${daysInactive > 1 ? 's' : ''}.`);
  } else {
    lines.push("Nous constatons que vous n'avez pas effectué de demande depuis quelques jours.");
  }
  lines.push('Avez-vous un besoin de transport actuellement ?');
  lines.push('');
  lines.push("L'équipe Baobab Connect reste à votre disposition pour vous accompagner.");
  lines.push('');
  lines.push('Cordialement,');
  lines.push("L'équipe Baobab Connect");
  return lines.join('\n');
};
